export default {
  items: [
    {
      name: 'Inicio',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: ''
      }
    },
    {
      name: 'Eventos',
      url: '/eventos',
      icon: 'cui-star',
    },
    {
      name: 'Sorteos Globales',
      url: '/sorteos-globales',
      icon: 'cui-star',
    },
  ]
}
